import type { GolfAutocomplete } from './golfs'
import type { Nullable } from './index'
import type { RegionAutocomplete } from './regions'
import type { Position } from './shared'
import type { LocationType } from './ui.interface'

export interface RegionParamsDto {
  fields?: string
}

export interface RegionsParamsDto extends RegionParamsDto {
  nom: string
}

export interface DepartementParamsDto {
  fields?: string
}

export interface DepartementsParamsDto extends DepartementParamsDto {
  nom?: string
  code?: string
  codeRegion?: string
}

export interface CityParamsDto {
  fields?: string
}

export interface DepartementDto {
  code: string
  nom: string
  codeRegion: string
  region: RegionDto
  _highlightResult: Match
}

export interface RegionDto {
  id: number
  name: string
}

export enum MatchLevel {
  NONE = 'none',
  FULL = 'full',
}

export interface Match {
  fullyHighlighted: boolean
  matchLevel: MatchLevel
  matchedWords: string[]
  value: string
}

export interface Geolocation {
  lat: number
  lng: number
}

// NEW
interface GouvRegionDto {
  nom: string
  code: string
}

interface LocaleRegionDto {
  id: number
  name: string
}

interface GouvDepartmentDto {
  nom: string
  code: string
  codeRegion: string
  region: GouvRegionDto
}

interface Country {
  code: string
  label: string
}

interface ResultsLocationCountry {
  value: Country
  type: LocationType.COUNTRY
}

interface ResultsLocationRegion {
  value: Nullable<RegionAutocomplete>
  type: LocationType.REGION
}

interface ResultsLocationDepartment {
  value: GouvDepartmentDto
  type: LocationType.DEPARTMENT
}

interface ResultsLocationCity {
  value: GouvCityDto
  type: LocationType.CITY
}

interface ResultsLocationProximity {
  type: LocationType.PROXIMITY
  value: Position
}

interface ResultsLocationGolf {
  type: LocationType.GOLF
  value: GolfAutocomplete
}

type ResultsLocation =
  | ResultsLocationGolf
  | ResultsLocationCountry
  | ResultsLocationRegion
  | ResultsLocationDepartment
  | ResultsLocationCity
  | ResultsLocationProximity

interface GouvCityDto {
  code: string
  nom: string
  codesPostaux: string[]
  codeDepartement: string
  codeRegion: string
  departement: {
    code: string
    nom: string
    codeRegion: string
    region: {
      code: string
      nom: string
    }
  }
  region: {
    code: string
    nom: string
  }
  population: number
  surface: number
  centre: {
    type: 'Point'
    coordinates: [number, number]
  }
  contour: unknown
  _score: number
}

export type {
  Country,
  GouvDepartmentDto,
  GouvRegionDto,
  GouvCityDto,
  ResultsLocation,
  ResultsLocationCountry,
  ResultsLocationRegion,
  ResultsLocationDepartment,
  ResultsLocationCity,
  ResultsLocationProximity,
  ResultsLocationGolf,
  LocaleRegionDto,
}
